/**
 * Палитрата на оцветените съобщения — ЕДИН източник за `InlineError`/`InlineStatus`
 * и `StatusPanel`.
 *
 * 🔴 Защо общ модул, а не копие във всеки компонент: две копия на „червеното за
 * грешка" се разминават тихо — едното се променя, другото не, и един и същ смисъл
 * излиза в два цвята на един екран. Типът не пази от това, защото и двете копия
 * са валидни низове.
 *
 * ⚠️ Компонентите четат палитрата при РЕНДЕР, не я копират при зареждане на модула.
 * Тестът за единния източник (`StatusPanel.test.tsx`) подменя стойност в този обект
 * и очаква промяната в ДВАТА компонента; копие в `const` на ниво модул би я
 * пропуснало и тестът би паднал.
 *
 * 📌 Класовете на `error`/`warning`/`success` са дословно тези, които `InlineError`
 * носеше преди изнасянето — 54-те му викания не бива да усетят промяна.
 */
export type StatusTone = 'success' | 'info' | 'warning' | 'danger';

export interface StatusToneStyle {
  /** Фон, рамка и цвят на текста на кутията. */
  surface: string;
  /** Цветът на иконката — по-наситен от текста, за да се различава при бърз поглед. */
  icon: string;
}

export const STATUS_PALETTE: Record<StatusTone, StatusToneStyle> = {
  success: { surface: 'bg-green-50 border-green-200 text-green-800', icon: 'text-green-600' },
  info: { surface: 'bg-blue-50 border-blue-200 text-blue-800', icon: 'text-blue-600' },
  warning: { surface: 'bg-yellow-50 border-yellow-200 text-yellow-800', icon: 'text-yellow-600' },
  danger: { surface: 'bg-red-50 border-red-200 text-red-700', icon: 'text-red-600' },
};
